// src/context/AuthContext.js
import { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profileUpdated, setProfileUpdated] = useState(null);
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!token) return setLoading(false);
      try {
        setIsAuthenticated(true);
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/disclaimer/status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDisclaimerAccepted(data.accepted === 'Accepted');
        setProfileUpdated(data.profileupdate === 1);
      } catch (err) {
        console.error(err);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [token]);
  const login = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken); // ✅ this triggers re-evaluation
  };
  const logout = () => {
    localStorage.removeItem('token');
    setToken(null); // ✅ this resets everything
    setIsAuthenticated(false);
    //setProfileUpdated(null);
    //setDisclaimerAccepted(null);
    setIsLoggingOut(true);
  };
  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      profileUpdated,
      disclaimerAccepted,
      setProfileUpdated,
      setDisclaimerAccepted,
      loading,
      login,
      logout,
      isLoggingOut,
      setIsLoggingOut,
      token
    }}>
      {children}
    </AuthContext.Provider>
  );
};
